import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import InvitationExperience from '../components/InvitationExperience';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InvitationView() {
  const { id } = useParams();
  const [inv, setInv] = useState(null);

  useEffect(() => {
    axios.get(`${API}/invitations/${id}`).then((r) => setInv(r.data)).catch(() => setInv(false));
  }, [id]);

  if (inv === null) return <div className="min-h-screen flex items-center justify-center bg-[#0e0708]"><Loader2 className="animate-spin text-[color:var(--burgundy)]" /></div>;
  if (inv === false) return <div className="min-h-screen flex items-center justify-center font-serif text-2xl bg-[#0e0708] text-[#f5e6d8]">Invito non trovato</div>;

  // Normalize field names for the shared experience component
  const data = {
    ...inv,
    image: inv.template_image || inv.custom_photo_url,
    event: inv.event_name,
    palette: inv.palette,
    font_style: inv.font_style,
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#0e0708' }}>
      <div className="w-full max-w-md">
        <InvitationExperience data={data} />
        <div className="text-center mt-6 text-white/50 text-xs tracking-widest">ITALIAN DIGITAL STORE · INVITI DIGITALI UNICI</div>
      </div>
    </div>
  );
}
